<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconExcelColored",
    props: {
        first_color: {
            type: String,
            default: '#3ca241',
        },
        second_color: {
            type: String,
            default: '#fff',
        },
        third_color: {
            type: String,
            default: '#f1f5f7',
        },
        fourth_color: {
            type: String,
            default: '#3ca241',
        }
    }
})
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
         width="512" height="512" style="enable-background:new 0 0 512 512"
         xml:space="preserve">
        <path
            d="M479.689 420.493H270.912c-8.23 0-14.91-6.698-14.91-14.953V106.479c0-8.255 6.68-14.952 14.91-14.952h208.777c8.234 0 14.914 6.697 14.914 14.952V405.54c.001 8.255-6.679 14.953-14.914 14.953zm0 0"
            :fill="third_color"/>
        <path
            d="M330.564 181.244h-59.652c-8.23 0-14.91-6.699-14.91-14.954 0-8.253 6.68-14.951 14.91-14.951h59.652c8.23 0 14.91 6.698 14.91 14.951.001 8.255-6.679 14.954-14.91 14.954zm0 59.813h-59.652c-8.23 0-14.91-6.697-14.91-14.956 0-8.247 6.68-14.947 14.91-14.947h59.652c8.23 0 14.91 6.7 14.91 14.947.001 8.258-6.679 14.956-14.91 14.956zm0 59.809h-59.652c-8.23 0-14.91-6.7-14.91-14.949 0-8.255 6.68-14.954 14.91-14.954h59.652c8.23 0 14.91 6.699 14.91 14.954.001 8.249-6.679 14.949-14.91 14.949zm0 59.817h-59.652c-8.23 0-14.91-6.698-14.91-14.953s6.68-14.954 14.91-14.954h59.652c8.23 0 14.91 6.699 14.91 14.954s-6.679 14.953-14.91 14.953zm89.475-179.439h-29.826c-8.23 0-14.914-6.699-14.914-14.954 0-8.253 6.684-14.951 14.914-14.951h29.826c8.229 0 14.91 6.698 14.91 14.951 0 8.255-6.681 14.954-14.91 14.954zm0 59.813h-29.826c-8.23 0-14.914-6.697-14.914-14.956 0-8.247 6.684-14.947 14.914-14.947h29.826c8.229 0 14.91 6.7 14.91 14.947 0 8.258-6.681 14.956-14.91 14.956zm0 59.809h-29.826c-8.23 0-14.914-6.7-14.914-14.949 0-8.255 6.684-14.954 14.914-14.954h29.826c8.229 0 14.91 6.699 14.91 14.954 0 8.249-6.681 14.949-14.91 14.949zm0 59.817h-29.826c-8.23 0-14.914-6.698-14.914-14.953s6.684-14.954 14.914-14.954h29.826c8.229 0 14.91 6.699 14.91 14.954s-6.681 14.953-14.91 14.953zm0 0"
            :fill="fourth_color"/>
        <path
            d="M280.428 35.153c-3.404-2.841-7.967-4.069-12.26-3.168L29.566 76.84c-7.068 1.322-12.169 7.481-12.169 14.687v328.966c0 7.177 5.101 13.364 12.169 14.688l238.602 44.856c.893.177 1.818.271 2.744.271 3.459 0 6.828-1.199 9.516-3.445 3.432-2.836 5.393-7.083 5.393-11.512V46.671c-.001-4.458-1.962-8.676-5.393-11.518zm0 0"
            :fill="first_color"/>
        <path
            d="m222.479 305.983-47.16-54.036 47.697-61.486c5.07-6.524 3.871-15.916-2.6-20.996-6.471-5.086-15.838-3.89-20.932 2.597l-44.175 56.943-37.22-42.64c-5.456-6.287-14.883-6.854-21.028-1.407-6.201 5.438-6.83 14.887-1.401 21.08l41.011 47.011-41.577 53.59c-5.072 6.522-3.877 15.916 2.592 20.997 2.746 2.123 6 3.14 9.188 3.14 4.443 0 8.831-1.973 11.779-5.775l38.03-49.045 43.363 49.68a14.791 14.791 0 0 0 11.213 5.141c3.492 0 6.984-1.227 9.82-3.712 6.202-5.438 6.825-14.888 1.4-21.082zm0 0"
            :fill="second_color"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
